import { openModal } from '../helpers/modal';
import OpensetModal from './openset-modal';
export default class DiyOpenset {
    static init(openset, slider) {
        this.openset = openset;
        this.slider = slider;
        this.container = document.querySelector('.diy-offer__selection');
        if (this.container) {
            this.unselectedElement = this.container.querySelector('.diy-offer__selection .unselected');
            this.leftToChooseContainer = this.container.querySelector('.left-to-choose');
            this.allSelectedContainer = this.container.querySelector('.all-selected');
            this.priceContainer = this.container.querySelector('.diy-offer__selection-price');
            if (this.priceContainer) {
                this.priceField = this.priceContainer.querySelector('strong');
            }
            this.items = this.container.querySelectorAll('.diy-offer__selection-product');
        }
    }
    static setProduct(index, product = null) {
        if (product !== null) {
            product = Object.assign({
                imageUrl: '/img/ts.gif',
                price: 0,
            }, product);
            this.selection[index] = product;
        }
        else {
            delete this.selection[index];
        }
        this.updateSelection();
    }
    static updateSelection() {
        const left = this.getProductsLeftToChoose();
        if (this.unselectedElement) {
            this.unselectedElement.textContent = left.toString();
        }
        // Pokazywanie/ukrywanie tekstu "Produktów do wyboru X z Y produktów"
        // Pokazywanie/ukrywanie przycisku "Add to cart"
        if (this.leftToChooseContainer && this.allSelectedContainer && this.priceContainer) {
            if (left === 0) {
                this.leftToChooseContainer.style.display = 'none';
                this.allSelectedContainer.style.display = 'block';
                this.priceContainer.classList.add('complete-set');
            }
            else {
                this.leftToChooseContainer.style.display = 'block';
                this.allSelectedContainer.style.display = 'none';
                this.priceContainer.classList.remove('complete-set');
            }
        }
        this.selection.forEach((product) => {
            if (product.price > this.highestCatalogPrice) {
                this.highestCatalogPrice = product.price;
            }
        });
        // Pokazywanie/ukrywanie ceny sumarycznej
        if (left === this.openset.details.productsNumber && this.priceContainer) {
            this.priceContainer.classList.remove('has-products');
        }
        else if (this.priceContainer && this.priceField) {
            this.priceContainer.classList.add('has-products');
            let totalPrice = 0;
            if (this.openset.type == 3) {
                totalPrice = this.highestCatalogPrice;
            }
            else {
                for (let i = 1; i <= this.openset.details.productsNumber; i++) {
                    if (this.isSelected(i)) {
                        totalPrice = totalPrice + this.selection[i].price;
                    }
                }
            }
            this.priceField.textContent = `${totalPrice.toFixed(this.openset.options.pricePrecision)} ${this.openset.options.currency}`;
        }
        if (this.items) {
            this.items.forEach((item) => {
                const index = item.dataset.index ? parseInt(item.dataset.index) : 1;
                let img = item.querySelector('img');
                if (this.isSelected(index)) {
                    item.classList.add('diy-offer__selection-product-chosen');
                    item.classList.remove('diy-offer__selection-product-empty');
                    if (img === null) {
                        img = document.createElement('img');
                        item.appendChild(img);
                    }
                    img.setAttribute('src', this.selection[index].imageUrl);
                }
                else {
                    item.classList.add('diy-offer__selection-product-empty');
                    item.classList.remove('diy-offer__selection-product-chosen');
                    if (img !== null) {
                        img.remove();
                    }
                }
                if (this.activeItem === index) {
                    item.classList.add('diy-offer__selection-product-active');
                }
                else {
                    item.classList.remove('diy-offer__selection-product-active');
                }
            });
        }
    }
    static getProductsLeftToChoose() {
        if (this.selection.length === 0) {
            return this.openset.details.productsNumber;
        }
        let unselected = 0;
        for (let i = 1; i <= this.openset.details.productsNumber; i++) {
            if (!this.isSelected(i)) {
                unselected = unselected + 1;
            }
        }
        return unselected;
    }
    static isSelected(index) {
        return this.selection !== null && typeof this.selection[index] === 'object' && this.selection[index] !== null;
    }
    static setActiveItem(index) {
        this.activeItem = index;
        this.updateSelection();
        if (this.slider) {
            const goTo = index - 2;
            if (goTo >= 0) {
                this.slider.goTo(goTo);
            }
        }
    }
    static showTab(index) {
        const wasActiveTabNull = this.activeTab == null;
        if (this.activeTab === index) {
            return;
        }
        this.activeTab = index;
        document.querySelectorAll('.openset-group').forEach((element) => {
            element.style.display = 'none';
        });
        document.querySelectorAll(`.openset-group[data-group="${index}"]`).forEach((element) => {
            element.style.display = 'block';
        });
        this.setActiveItem(index + 1);
        const opensetGroup = document.querySelector(`.openset-group[data-group="${index}"]`);
        if (opensetGroup && !wasActiveTabNull) {
            opensetGroup.scrollIntoView({ behavior: 'smooth' });
        }
    }
    static addToCart() {
        const selectedProducts = [];
        document.querySelectorAll('.openset-page__groups .prod-tile.checked').forEach((product) => {
            const productPriceMeta = product.querySelector('meta[itemprop=price]');
            const productSkuMeta = product.querySelector('meta[itemprop=sku]');
            const opensetGroup = product.closest('.openset-group');
            if (opensetGroup && opensetGroup.dataset)
                if (productPriceMeta && productSkuMeta && opensetGroup && opensetGroup.dataset) {
                    const productPrice = productPriceMeta.getAttribute('content');
                    const productSku = productSkuMeta.getAttribute('content');
                    if (productPrice && productSku && opensetGroup.dataset.group) {
                        selectedProducts.push({
                            group: opensetGroup.dataset.group,
                            price: parseFloat(productPrice),
                            quantity: 1,
                            sku: productSku,
                        });
                    }
                }
        });
        if (selectedProducts.length > 0) {
            const remoteUrl = this.openset.options.remoteUrl;
            const formData = new FormData();
            formData.append('products', JSON.stringify(selectedProducts));
            formData.append('openset', this.openset.details.sku);
            fetch(remoteUrl, {
                method: 'POST',
                cache: 'no-cache',
                body: formData,
            })
                .then((response) => {
                if (response.ok === false) {
                    throw new Error('Unknown failure');
                }
                return response.text();
            })
                .then((response) => {
                openModal(response, (modal) => {
                    OpensetModal.init(modal, this.openset.details.sku);
                });
            })
                .catch((err) => {
                console.error(err);
            });
        }
    }
}
DiyOpenset.selection = [];
DiyOpenset.highestCatalogPrice = 0;
DiyOpenset.activeItem = 1;
DiyOpenset.activeTab = null;
